import { arrayRequired, labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  arrayRequired(
    Joi,
    Joi.object()
      .keys({
        isPreferred: Joi.boolean()
      })
      .label(labeled(label, 'Recommended'))
  )
    .has(
      Joi.object().keys({
        isPreferred: Joi.boolean().invalid(false).required()
      })
    )
    .label(labeled(label, 'Split -'));

export default {
  schema
};
